import { Card } from '../components/Card'
import { ManualKeyPanel } from '../components/ManualKeyPanel'
import { StepBadge } from '../components/StepBadge'

/**
 * Step 2 of 4 Alternative: Enter Setup Key Manually.
 * Ported from the web client's `/login/setup-authenticator/manual-key` page.
 */
export function ManualKeyPage() {
  return (
    <Card>
      {/* 1. Accessible Step Badge */}
      <StepBadge step={2} />

      {/* 2. Heading */}
      <header className="flex flex-col gap-2">
        <h1 className="text-xl font-bold tracking-tight text-brand-dark-text">
          Enter your setup key
        </h1>
        <p className="text-sm text-brand-copyright leading-relaxed">
          Can&apos;t scan the QR code? Copy the key below into your authenticator app manually.
        </p>
      </header>

      {/* 3. Interactive key display + controls */}
      <ManualKeyPanel />
    </Card>
  )
}
